import RaisedButton from 'material-ui/RaisedButton';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import React from 'react';
import { resourceApi } from '../utils/fetchUtil';

class UpdateButton extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fetching:true,
            url:undefined,
        }
    }

    componentDidMount(){
        this.getStoreLink();
    }

    getWhiteLabelKey(){    
        if(window.COMPANY_ID != undefined){
            return window.COMPANY_ID;
        }
        else {
            return 0;
        }
    }

    getPlatform = () => {
        if(window.device){
            return window.device.platform.toLowerCase();
        }
        else if(window.cordova && window.cordova.platformId){
            return window.cordova.platformId.toLowerCase();
        }
        else {
            return 'pc'
        }
    }

    getStoreLink = () => {

        let config = {
            method:'get',
            url:`application/updates`
        }
        console.log(config);

        resourceApi(config)
        .then(res => {
            console.log("Response of type", typeof res.data, res.data);
            let dasObject = res.data;
            let platform = this.getPlatform();

            switch (platform) {
                case 'ios':
                    this.setState({url:dasObject.AppStore},()=>{this.setState({fetching:false})})
                    break;
                case 'android':
                    this.setState({url:dasObject.PlayStore},()=>{this.setState({fetching:false})})
                    break;
                default:
                    this.setState({url:''},()=>{this.setState({fetching:false})})
                    break;
            }
        })
        .catch(err => console.log(err));
    }



    render(){

        const primary = getMuiTheme(window.muiTheme).palette.primary1Color;


        return (
            <div>
                {this.state.url === '' && this.state.fetching === false && (
                    <div style={{padding:'10px 0 10px 0'}}>
                        {this.getPlatform() === 'pc' ? (
                            <span style={{color:'red'}}>Something went wrong, please visit either the Google Play Store or Apple App Store to update the App.</span>
                        ):(
                            <span>{`Something went wrong, visit the ${this.getPlatform() === 'ios' ? 'Apple App Store' : 'Google Play Store'} to update today.`}</span>
                        )}

                    </div>
                )}
                {this.getPlatform() === 'ios' && (
                    <button className={'button-style'} style={{backgroundColor:primary}} onClick={()=>{window.open(`${this.state.url}`)}}><label>Update Now</label></button>
                )}
                {this.getPlatform() === 'android' && (
                    <button className={'button-style'} style={{backgroundColor:primary}} href={`${this.state.url}`}><label>UPDATE NOW</label></button>
                )}
            </div>
        )
    }
}

export default UpdateButton;


// WEBPACK FOOTER //
// ./src/Components/UpdateButton.js